import { CompanyType } from "../Enums/Enums";
import { AppArea } from "../Enums/AppArea";

export const getTranslation = (
    companyType: CompanyType,
    area: AppArea,
    plural: boolean
) => {
    let word = "";
    switch (area) {
        case AppArea.LOCATIONS: {
            word = getLocationsWord(companyType, plural);
            break;
        }
        case AppArea.CUSTOMERS: {
            word = getCustomersWord(companyType, plural);
            break;
        }
        case AppArea.SALES: {
            word = getSalesWord(companyType, plural);
            break;
        }
        case AppArea.TERRITORIES: {
            word = getTerritoryWord(companyType, plural);
            break;
        }
        case AppArea.COMPETITORS: {
            word = getCompetitorWord(companyType, plural);
            break;
        }
        case AppArea.COTENANTS: {
            word = getCotenantWord(companyType, plural);
            break;
        }
    }
    return word;
};

const getTerritoryWord = (
    companyType: CompanyType,
    plural: boolean
): string => {
    let word = "";

    switch (companyType) {
        case CompanyType.RETAILER: {
            word = plural ? "Territories" : "Territory";
            break;
        }
        case CompanyType.HEALTHCARE: {
            word = plural ? "Territories" : "Territory";
            break;
        }
        case CompanyType.HOTEL: {
            word = plural ? "Custom Polygons" : "Custom Polygon";
            break;
        }
        case CompanyType.MARRIOTT: {
            word = plural ? "Territories" : "Territory";
            break;
        }
        case CompanyType.COMMUNITY: {
            word = plural ? "Territories" : "Territory";
            break;
        }
        case CompanyType.COMMERCIAL_REAL_ESTATE: {
            word = plural ? "Custom Polygons" : "Custom Polygon";
            break;
        }
    }

    return word;
};

const getCompetitorWord = (
    companyType: CompanyType,
    plural: boolean
): string => {
    let word = "";

    switch (companyType) {
        case CompanyType.RETAILER: {
            word = plural ? "Competitors" : "Competitor";
            break;
        }
        case CompanyType.HEALTHCARE: {
            word = plural ? "Competitors" : "Competitor";
            break;
        }
        case CompanyType.HOTEL: {
            word = plural ? "Competitors" : "Competitor";
            break;
        }
        case CompanyType.MARRIOTT: {
            word = plural ? "Competitors" : "Competitor";
            break;
        }
        case CompanyType.COMMUNITY: {
            word = plural ? "Competitors" : "Competitor";
            break;
        }
        case CompanyType.COMMERCIAL_REAL_ESTATE: {
            word = plural ? "Leads" : "Lead";
            break;
        }
    }

    return word;
};

const getCotenantWord = (companyType: CompanyType, plural: boolean): string => {
    let word = "";

    switch (companyType) {
        case CompanyType.RETAILER: {
            word = plural ? "Cotenants" : "Cotenant";
            break;
        }
        case CompanyType.HEALTHCARE: {
            word = plural ? "Cotenants" : "Cotenant";
            break;
        }
        case CompanyType.HOTEL: {
            word = plural ? "Cotenants" : "Cotenant";
            break;
        }
        case CompanyType.MARRIOTT: {
            word = plural ? "Cotenants" : "Cotenant";
            break;
        }
        case CompanyType.COMMUNITY: {
            word = plural ? "Cotenants" : "Cotenant";
            break;
        }
        case CompanyType.COMMERCIAL_REAL_ESTATE: {
            word = plural ? "Partners" : "Partner";
            break;
        }
    }

    return word;
};

const getLocationsWord = (
    companyType: CompanyType,
    plural: boolean
): string => {
    let word = "";
    switch (companyType) {
        case CompanyType.RETAILER: {
            word = plural ? "Stores" : "Store";
            break;
        }
        case CompanyType.HEALTHCARE: {
            word = plural ? "Facilities" : "Facility";
            break;
        }
        case CompanyType.HOTEL: {
            word = plural ? "Hotels" : "Hotel";
            break;
        }
        case CompanyType.MARRIOTT: {
            word = plural ? "Hotels" : "Hotel";
            break;
        }
        case CompanyType.COMMUNITY: {
            word = plural ? "Sites" : "Site";
            break;
        }
        case CompanyType.COMMERCIAL_REAL_ESTATE: {
            word = plural ? "Properties" : "Property";
            break;
        }
    }
    return word;
};

const getCustomersWord = (
    companyType: CompanyType,
    plural: boolean
): string => {
    let word = "";
    switch (companyType) {
        case CompanyType.COMMERCIAL_REAL_ESTATE:
        case CompanyType.RETAILER: {
            word = plural ? "Customers" : "Customer";
            break;
        }
        case CompanyType.HEALTHCARE: {
            word = plural ? "Patients" : "Patient";
            break;
        }
        case CompanyType.HOTEL: {
            word = plural ? "Customers" : "Customer";
            break;
        }
        case CompanyType.MARRIOTT: {
            word = plural ? "Customers" : "Customer";
            break;
        }
        case CompanyType.COMMUNITY: {
            word = plural ? "Profiles" : "Profile";
            break;
        }
    }
    return word;
};

export const getSalesWord = (companyType: CompanyType, plural: boolean): string => {
    let word = "";
    switch (companyType) {
        case CompanyType.COMMERCIAL_REAL_ESTATE:
        case CompanyType.RETAILER: {
            word = plural ? "Sales" : "Sale";
            break;
        }
        case CompanyType.HEALTHCARE: {
            word = plural ? "Visits" : "Visit";
            break;
        }
        case CompanyType.HOTEL: {
            word = plural ? "Sales" : "Sale";
            break;
        }
        case CompanyType.MARRIOTT: {
            word = plural ? "Sales" : "Sale";
            break;
        }
        case CompanyType.COMMUNITY: {
            word = plural ? "Sales" : "Sale";
            break;
        }
    }
    return word;
};
